import { SGPlugin } from '../common/SGPlugins'
import AsyncModal, { type AsyncModalTagProps } from '../components/AsyncModal'
import { showModal } from '../common/helpers'

const registerHandler = (element: HTMLElement) => {
  // Не добавляем хэндлер ещё раз, в случае мутации
  if (element.hasAttribute('data-async-modal-attached')) {
    return
  }

  element.setAttribute('data-async-modal-attached', 'true')

  if (element instanceof HTMLFormElement) {
    element.addEventListener('submit', (event) => {
      event.preventDefault()
      const href = element.action
      const method = element.method
      const formData = new FormData(element)

      showModal(AsyncModal, { href, method, formData })
    })
    return
  }

  element.addEventListener('click', (event) => {
    event.preventDefault()
    const options = SGPlugin.getElementOptions<Omit<AsyncModalTagProps, 'formData'>>(element, 'async-modal', false)
    showModal(AsyncModal, options)
  })
}

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach(registerHandler)
}
